import { useEffect, useState } from "react";

import EasyTimer from "easytimer.js";
import { DateTime } from "luxon";

import { Typography } from "@components/Typography";

import { useBroadcastStatusDataQuery } from "@storage/queries/broadcast/useBroadcastStatusDataQuery";

const timer = new EasyTimer();

const hh = "00",
	mm = "00",
	ss = "00";

export const PrivateRequestTimer = () => {
	const [time, setTime] = useState<string | null>(null);
	const { privateInfo } = useBroadcastStatusDataQuery();
	const privateModeStartedAt = privateInfo?.privateModeStartedAt ?? 0;

	useEffect(() => {
		if (privateModeStartedAt <= 0) {
			timer.stop();
			timer.removeAllEventListeners();
			setTime(null);
			return;
		}

		const elapsedSeconds = Math.max(0, Math.floor(DateTime.now().toSeconds() - privateModeStartedAt));
		const handleSecondsUpdated = () => {
			setTime(timer.getTimeValues().toString());
		};

		timer.stop();
		timer.removeAllEventListeners();
		timer.start({
			precision: "seconds",
			startValues: { seconds: elapsedSeconds },
		});
		setTime(timer.getTimeValues().toString());
		timer.addEventListener("secondsUpdated", handleSecondsUpdated);

		return () => {
			timer.removeEventListener("secondsUpdated", handleSecondsUpdated);
			timer.stop();
		};
	}, [privateModeStartedAt]);

	return (
		<div className="flex items-center">
			{time ? (
				<Typography type="span" className="w-19.5" padding="none">
					{time}
				</Typography>
			) : (
				<>
					<Typography size="sm" padding="none" align="right">
						{hh}:
					</Typography>
					<Typography size="sm" padding="none" align="right">
						{mm}:
					</Typography>
					<Typography size="sm" padding="none" align="right">
						{ss}
					</Typography>
				</>
			)}
		</div>
	);
};
